import { motion } from 'framer-motion';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import PeopleIcon from '@mui/icons-material/People';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import { useNavigate } from 'react-router-dom';
import Footer from '../Materials/Footer';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import MapIcon from '@mui/icons-material/Map';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects';
import GroupsIcon from '@mui/icons-material/Groups';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';

import '../MainPage/mainpage.css';

export default function LandingPage() {
  const navigate = useNavigate();

  return (
    <Box sx={{ flexGrow: 1 }}>
      {/* Secção da Ideation Platform */}
      <Box 
        sx={{
          backgroundImage: 'linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url("/visao_hub.png.jpg")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          color: 'white',
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          position: 'relative', 
          paddingLeft: '0px !important', 
          marginLeft: '0px !important' 
        }}
      >
        <Box sx={{ 
          marginLeft: { xs: '20px', md: '50px', lg: '80px' },
          maxWidth: '600px'
        }}>
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            {/* Título principal */}
            <Typography 
              variant="h2" 
              component="h1"
              gutterBottom
              sx={{ 
                fontWeight: 'bold',
                mb: 2, 
                fontSize: { xs: '2.5rem', md: '3rem', textShadow: '1px 1px 3px rgba(0,0,0,0.9)' }
              }}
            >
              Hub4Food<sup>®</sup> 
            </Typography>
            
            {/* Descrição */}
            <Typography 
              variant="h5" 
              component="p"
              sx={{ 
                mb: 2, 
                lineHeight: 1.6,
                fontSize: { xs: '1.2rem', md: '1.4rem', textShadow: '1px 1px 3px rgba(0,0,0,0.9)' }
              }}
            >
              Hub4Food connects researchers, industries, and institutions to advance 
              agri-food science and sustainable development.
            </Typography>

            {/* Botão Get Started - vai para login */}
            <Button 
              variant="contained" 
              size="large"
              sx={{
                backgroundColor: '#3FA5D4',
                '&:hover': {
                  backgroundColor: '#2E8DB8'
                },
                px: 6,
                py: 2,
                fontSize: '1.2rem',
                fontWeight: 'bold',
                mb: 9, 
                borderRadius: '35px'
              }}
              onClick={() => navigate('/login')} 
            >
              Join Us
            </Button>

            <Box>
              <Typography 
                variant="body1"
                sx={{ 
                  mb: 1,
                  fontSize: '1.2rem',
                  fontWeight: 'bold',
                  textShadow: '1px 1px 3px rgba(0,0,0,0.9)'
                }}
              >
                We are more than a partner
              </Typography>
              
              <Typography 
                variant="body1" 
                component="p"
                sx={{ 
                  fontWeight: '400',
                  fontStyle: 'italic',
                  fontSize: '1.1rem',
                  lineHeight: 1.4,
                  textShadow: '1px 1px 3px rgba(0,0,0,0.9)'
                }}
              >
                We are your trusted partner to turn your ideas into innovative solutions!
              </Typography>
            </Box>
          </motion.div>
        </Box>
      </Box>

{/*  How It Works */}
{/* How It Works */}
<Box
  id="how-it-works"
  sx={{
    position: 'relative',
    overflow: 'hidden',
    background: 'linear-gradient(180deg, #ffffff 0%, #f7fbfe 100%)',
    py: { xs: 7, md: 9 }
  }}
>
  {/* Decorative background */}
  <Box
    sx={{
      position: 'absolute',
      width: 380,
      height: 380,
      borderRadius: '50%',
      background: 'linear-gradient(135deg, rgba(63,165,212,0.12), rgba(76,175,80,0.08))',
      top: -200,
      left: -160
    }}
  />

  <Box
    sx={{
      position: 'absolute',
      width: 420,
      height: 420,
      borderRadius: '50%',
      background: 'linear-gradient(135deg, rgba(63,165,212,0.08), rgba(25,118,210,0.12))',
      bottom: -260,
      right: -180
    }}
  />

  <Container maxWidth={false} sx={{ maxWidth: '1600px', position: 'relative', zIndex: 2 }}>

    <motion.div
      initial={{ opacity: 0, y: 35 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.7 }}
    >
      {/* Small Hub4Food label */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 2,
          mb: 1.5
        }}
      >
        <Box sx={{ width: 42, height: '1px', backgroundColor: '#b9dce8' }} />

        <Box
          sx={{
            px: 2.2,
            py: 0.5,
            borderRadius: '30px',
            backgroundColor: 'rgba(63,165,212,0.09)',
            color: '#159ab1',
            fontSize: '0.72rem',
            fontWeight: 800,
            letterSpacing: '5px'
          }}
        >
          HUB4FOOD
        </Box>

        <Box sx={{ width: 42, height: '1px', backgroundColor: '#b9dce8' }} />
      </Box>

      {/* Title */}
      <Typography
        component="h2"
        align="center"
        sx={{
          fontWeight: 800,
          color: '#10254a',
          fontSize: { xs: '2.5rem', md: '3.5rem' },
          lineHeight: 1.05,
          mb: 1.5
        }}
      >
        How It Works
      </Typography>

      <Typography
        align="center"
        sx={{
          color: '#6b7891',
          fontSize: { xs: '1rem', md: '1.2rem' },
          mb: { xs: 6, md: 7 }
        }}
      >
        A simple path to collaborate, discover opportunities, and grow your network.
      </Typography>

      <Box
        sx={{
          overflowX: { xs: 'auto', lg: 'visible' },
          pb: 2,
          '&::-webkit-scrollbar': {
            height: 6
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#cbd5e1',
            borderRadius: 10
          }
        }}
      >
        <Box
          sx={{
            position: 'relative',
            display: 'grid',
            gridTemplateColumns: 'repeat(5, minmax(220px, 1fr))',
            gap: 3,
            minWidth: { xs: 1250, lg: 'auto' },
            px: { xs: 1, md: 2 }
          }}
        >
          {/* Horizontal timeline */}
          <Box
            sx={{
              position: 'absolute',
              top: 28,
              left: '9%',
              right: '9%',
              height: 3,
              borderRadius: 20,
              background:
                'linear-gradient(90deg, #2587e8 0%, #31b84b 25%, #ffa726 50%, #15aa9b 75%, #1976d2 100%)',
              zIndex: 0
            }}
          />

          {[
            {
              number: 1,
              icon: <PersonAddAlt1Icon sx={{ fontSize: 48 }} />,
              title: 'Sign Up / Log In',
              desc: "Create your entity's profile to start collaborating.",
              color: '#2587e8',
              softColor: '#eaf4ff'
            },
            {
              number: 2,
              icon: <MapIcon sx={{ fontSize: 48 }} />,
              title: 'Explore Entities & Network',
              desc: 'Look for relevant entities connected to your research.',
              color: '#31ad4c',
              softColor: '#eaf8ee'
            },
            {
              number: 3,
              icon: <AssignmentTurnedInIcon sx={{ fontSize: 48 }} />,
              title: 'Participate in Calls & Opportunities',
              desc: 'Register for collaborative investigation and funding calls.',
              color: '#ffa726',
              softColor: '#fff5e6'
            },
            {
              number: 4,
              icon: <EmojiObjectsIcon sx={{ fontSize: 48 }} />,
              title: 'Create & Share Ideas',
              desc: 'Describe and share your innovative research ideas.',
              color: '#16aa9b',
              softColor: '#e7f8f6'
            },
            {
              number: 5,
              icon: <GroupsIcon sx={{ fontSize: 48 }} />,
              title: 'Networking & Speed Meetings',
              desc: 'Take part in quick meetings to connect with other entities.',
              color: '#1976d2',
              softColor: '#e8f3fc'
            }
          ].map((step, index, steps) => (
            <Box
              key={step.number}
              sx={{
                position: 'relative',
                zIndex: 1
              }}
            >
              {/* Step number */}
              <Box
                sx={{
                  width: 58,
                  height: 58,
                  borderRadius: '50%',
                  backgroundColor: step.color,
                  color: '#fff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mx: 'auto',
                  position: 'relative',
                  zIndex: 3,
                  fontSize: '1.55rem',
                  fontWeight: 800,
                  boxShadow: `0 8px 20px ${step.color}35`
                }}
              >
                {step.number}
              </Box>

              {/* Arrow */}
              {index < steps.length - 1 && (
                <Box
                  sx={{
                    position: 'absolute',
                    top: 10,
                    right: -27,
                    width: 38,
                    height: 38,
                    borderRadius: '50%',
                    backgroundColor: '#fff',
                    boxShadow: '0 4px 14px rgba(15, 23, 42, 0.13)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 4
                  }}
                >
                  <ChevronRightIcon
                    sx={{
                      color: step.color,
                      fontSize: 26
                    }}
                  />
                </Box>
              )}

              <motion.div
                whileHover={{
                  y: -8
                }}
                transition={{
                  type: 'spring',
                  stiffness: 260,
                  damping: 18
                }}
              >
                <Box
                  sx={{
                    mt: -1.5,
                    position: 'relative',
                    minHeight: 310,
                    backgroundColor: '#ffffff',
                    borderRadius: '22px',
                    pt: 7,
                    px: 3,
                    pb: 4,
                    textAlign: 'center',
                    boxShadow: '0 10px 28px rgba(15, 23, 42, 0.08)',
                    border: '1px solid rgba(15, 23, 42, 0.035)',
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center'
                  }}
                >
                  {/* Icon background */}
                  <Box
                    sx={{
                      width: 96,
                      height: 96,
                      borderRadius: '50%',
                      backgroundColor: step.softColor,
                      color: step.color,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mb: 2.5
                    }}
                  >
                    {step.icon}
                  </Box>

                  <Typography
                    sx={{
                      color: '#10254a',
                      fontWeight: 800,
                      fontSize: '1.12rem',
                      lineHeight: 1.3,
                      mb: 1.5,
                      minHeight: 56,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    {step.title}
                  </Typography>

                  <Typography
                    sx={{
                      color: '#6b7891',
                      lineHeight: 1.55,
                      fontSize: '0.95rem',
                      maxWidth: 230
                    }}
                  >
                    {step.desc}
                  </Typography>

                  {/* Bottom coloured accent */}
                  <Box
                    sx={{
                      position: 'absolute',
                      left: 0,
                      right: 0,
                      bottom: 0,
                      height: 6,
                      backgroundColor: step.color
                    }}
                  />
                </Box>
              </motion.div>
            </Box>
          ))}
        </Box>
      </Box>

      {/* Bottom tagline */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mt: 6,
          gap: 2
        }}
      >
        <Box
          sx={{
            width: { xs: 25, md: 55 },
            height: '1px',
            backgroundColor: '#b8cad8'
          }}
        />

        <Typography
          sx={{
            color: '#8293aa',
            textTransform: 'uppercase',
            letterSpacing: { xs: '2px', md: '5px' },
            fontSize: { xs: '0.58rem', md: '0.72rem' },
            fontWeight: 600,
            textAlign: 'center'
          }}
        >
          Together for a sustainable food future
        </Typography>

        <Box
          sx={{
            width: { xs: 25, md: 55 },
            height: '1px',
            backgroundColor: '#b8cad8'
          }}
        />
      </Box>
    </motion.div>
  </Container>
</Box>


  {/* Nova Secção: Hub4Food® Services */}
<Box
  sx={{
    position: 'relative',
    overflow: 'hidden',
    minHeight: { xs: 'auto', md: '620px' },
    display: 'flex',
    alignItems: 'center',
    background:
      'radial-gradient(circle at 58% 20%, rgba(67, 112, 137, 0.40) 0%, rgba(18, 45, 62, 0.15) 32%, transparent 55%), linear-gradient(115deg, #071722 0%, #0c2230 48%, #173848 100%)',
    color: '#fff',
    py: { xs: 6, md: 7 }
  }}
>
  {/* Decorative circles */}
  <Box
    sx={{
      position: 'absolute',
      width: 600,
      height: 600,
      borderRadius: '50%',
      border: '1px solid rgba(70, 190, 158, 0.25)',
      right: -330,
      top: -110,
      pointerEvents: 'none'
    }}
  />

  <Box
    sx={{
      position: 'absolute',
      width: 600,
      height: 600,
      borderRadius: '50%',
      border: '1px solid rgba(70, 190, 158, 0.20)',
      right: -400,
      top: 35,
      pointerEvents: 'none'
    }}
  />

  <Container
    maxWidth={false}
    sx={{
      maxWidth: '1700px',
      position: 'relative',
      zIndex: 2,
      px: { xs: 3, md: 7, lg: 9 }
    }}
  >
    <Grid
      container
      spacing={{ xs: 6, md: 8 }}
      alignItems="center"
    >
      {/* LEFT SIDE */}
      <Grid item xs={12} md={6}>
        <motion.div
          initial={{ opacity: 0, x: -35 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          {/* Small green line */}
          <Box
            sx={{
              width: 82,
              height: 5,
              borderRadius: 10,
              backgroundColor: '#56c6a5',
              mb: 4
            }}
          />

          {/* Title */}
          <Typography
            component="h2"
            sx={{
              fontWeight: 800,
              color: '#fff',
              fontSize: {
                xs: '2.6rem',
                sm: '3rem',
                md: '3.1rem',
                lg: '3.5rem'
              },
              whiteSpace: { lg: 'nowrap' },
              lineHeight: 1.05,
              mb: 4.5,
              letterSpacing: '-1px'
            }}
          >
            Hub4Food<sup>®</sup> Services
          </Typography>

          {/* Services */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2.1,
              mb: 5
            }}
          >
            {[
              {
                icon: <LightbulbOutlinedIcon sx={{ fontSize: 28 }} />,
                title: 'Innovation & Ideation Platform'
              },
              {
                icon: <GroupsOutlinedIcon sx={{ fontSize: 29 }} />,
                title: 'Speed meetings & Networking'
              },
              {
                icon: <CampaignOutlinedIcon sx={{ fontSize: 28 }} />,
                title: 'Calls & Opportunities'
              },
              {
                icon: <BarChartOutlinedIcon sx={{ fontSize: 28 }} />,
                title: 'Regulatory Insights'
              }
            ].map((service, index) => (
              <Box
                key={index}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2.4
                }}
              >
                <Box
                  sx={{
                    width: 52,
                    height: 52,
                    minWidth: 52,
                    borderRadius: '50%',
                    backgroundColor: 'rgba(86, 198, 165, 0.19)',
                    color: '#f4fffb',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '1px solid rgba(86, 198, 165, 0.10)'
                  }}
                >
                  {service.icon}
                </Box>

                <Typography
                  sx={{
                    color: '#fff',
                    fontSize: {
                      xs: '1.15rem',
                      md: '1.28rem',
                      lg: '1.4rem'
                    },
                    fontWeight: 400,
                    lineHeight: 1.3
                  }}
                >
                  {service.title}
                </Typography>
              </Box>
            ))}
          </Box>

          {/* Description */}
          <Typography
            component="p"
            sx={{
              color: 'rgba(255,255,255,0.88)',
              fontStyle: 'italic',
              fontSize: {
                xs: '1rem',
                md: '1.12rem',
                lg: '1.2rem'
              },
              lineHeight: 1.75,
              maxWidth: '720px',
              mb: 1.4
            }}
          >
            Hub4Food<sup>®</sup> is the platform that connects science, industry,
            and technology to accelerate food innovation.
          </Typography>

          <Typography
            sx={{
              color: '#fff',
              fontWeight: 800,
              fontSize: {
                xs: '1.1rem',
                md: '1.22rem',
                lg: '1.3rem'
              }
            }}
          >
            Access digital tools, reports, and unique opportunities!
          </Typography>
        </motion.div>
      </Grid>

      {/* RIGHT SIDE */}
      <Grid item xs={12} md={6}>
        <motion.div
          initial={{ opacity: 0, x: 35 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.15 }}
        >
          <Box
            sx={{
              position: 'relative',
              width: '100%',
              maxWidth: '680px',
              mx: 'auto',
              borderRadius: '24px',
              overflow: 'hidden',
              border: '1px solid rgba(255,255,255,0.32)',
              boxShadow: '0 24px 55px rgba(0,0,0,0.30)'
            }}
          >
            <Box
              component="img"
              src="/mainpage-section2.jpg"
              alt="Hub4Food Services"
              sx={{
                display: 'block',
                width: '100%',
                height: {
                  xs: '300px',
                  sm: '360px',
                  md: '400px',
                  lg: '430px'
                },
                objectFit: 'cover',
                objectPosition: 'center'
              }}
            />

            {/* Very subtle image overlay */}
            <Box
              sx={{
                position: 'absolute',
                inset: 0,
                background:
                  'linear-gradient(180deg, rgba(6,21,31,0.03) 0%, rgba(6,21,31,0.10) 100%)',
                pointerEvents: 'none'
              }}
            />
          </Box>
        </motion.div>
      </Grid>
    </Grid>
  </Container>
</Box>

      {/* Why Hub4Food */}
<Box
  sx={{
    width: '100%',
    background: 'linear-gradient(180deg, #ffffff 0%, #f8fbfe 100%)',
    py: { xs: 5, md: 6 }
  }}
>
  <Container
    maxWidth="lg"
    sx={{
      px: { xs: 2.5, md: 3 }
    }}
  >
    <motion.section
      id="why"
      initial={{ opacity: 0, y: 35 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.7 }}
    >
      {/* OUR IMPACT */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 2,
          mb: 1.3
        }}
      >
        <Box
          sx={{
            width: 55,
            height: '2px',
            backgroundColor: '#1976d2'
          }}
        />

        <Typography
          sx={{
            color: '#1976d2',
            fontWeight: 600,
            letterSpacing: '4px',
            fontSize: { xs: '0.7rem', md: '0.8rem' }
          }}
        >
          OUR IMPACT
        </Typography>

        <Box
          sx={{
            width: 55,
            height: '2px',
            backgroundColor: '#1976d2'
          }}
        />
      </Box>

      {/* TITLE */}
      <Typography
        component="h2"
        align="center"
        sx={{
          fontWeight: 800,
          color: '#10254a',
          fontSize: {
            xs: '2.2rem',
            sm: '2.5rem',
            md: '2.8rem'
          },
          lineHeight: 1.1,
          mb: 1.3
        }}
      >
        Why Hub4Food<sup>®</sup>?
      </Typography>

      {/* SUBTITLE */}
      <Typography
        align="center"
        sx={{
          color: '#748198',
          fontSize: {
            xs: '0.95rem',
            md: '1.05rem'
          },
          lineHeight: 1.6,
          maxWidth: '760px',
          mx: 'auto',
          mb: { xs: 4, md: 4.5 }
        }}
      >
        We bring together people, knowledge and technology to create real impact
        in the agri-food sector.
      </Typography>

      {/* CARDS */}
      <Grid
        container
        spacing={{ xs: 2.5, md: 3 }}
        justifyContent="center"
        alignItems="stretch"
      >
        {[
          {
            icon: <LightbulbOutlinedIcon sx={{ fontSize: 44 }} />,
            title: 'Access Technologies',
            desc: 'Access curated technologies and equipment from top research entities.',
            color: '#1976d2',
            softColor: '#eaf4ff'
          },
          {
            icon: <PeopleIcon sx={{ fontSize: 46 }} />,
            title: 'Connect Stakeholders',
            desc: 'Connect with international stakeholders to form impactful partnerships.',
            color: '#f5b41b',
            softColor: '#fff5dc'
          },
          {
            icon: <TrendingUpIcon sx={{ fontSize: 46 }} />,
            title: 'Boost Productivity',
            desc: "Optimize Europe's tech ecosystem to save time and increase productivity.",
            color: '#35ad54',
            softColor: '#eaf8ee'
          }
        ].map((item, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <motion.div
              whileHover={{ y: -5 }}
              transition={{
                type: 'spring',
                stiffness: 250,
                damping: 18
              }}
              style={{ height: '100%' }}
            >
              <Box
                sx={{
                  height: '100%',
                  minHeight: { xs: 260, md: 280 },
                  backgroundColor: '#fff',
                  borderRadius: '20px',
                  px: { xs: 3, md: 3.5 },
                  py: { xs: 3, md: 3.5 },
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  textAlign: 'center',
                  border: '1px solid rgba(15, 23, 42, 0.04)',
                  boxShadow: '0 8px 24px rgba(15, 23, 42, 0.07)'
                }}
              >
                {/* ICON CIRCLE */}
                <Box
                  sx={{
                    width: { xs: 90, md: 96 },
                    height: { xs: 90, md: 96 },
                    borderRadius: '50%',
                    backgroundColor: item.softColor,
                    color: item.color,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mb: 2.2
                  }}
                >
                  {item.icon}
                </Box>

                {/* CARD TITLE */}
                <Typography
                  sx={{
                    fontWeight: 800,
                    color: '#10254a',
                    fontSize: {
                      xs: '1.18rem',
                      md: '1.3rem'
                    },
                    lineHeight: 1.3,
                    mb: 1
                  }}
                >
                  {item.title}
                </Typography>

                {/* DESCRIPTION */}
                <Typography
                  sx={{
                    color: '#647186',
                    fontSize: {
                      xs: '0.92rem',
                      md: '0.97rem'
                    },
                    lineHeight: 1.55,
                    maxWidth: '290px'
                  }}
                >
                  {item.desc}
                </Typography>
              </Box>
            </motion.div>
          </Grid>
        ))}
      </Grid>
    </motion.section>
  </Container>
</Box>

{/* Conteúdo principal */}
<Container
  maxWidth="md"
  sx={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    py: 3,
  }}
>
  {/* Secções informativas */}
<motion.section
  className="info"
  id="arriving"
  initial={{ opacity: 0, y: 40 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true }}
  transition={{ duration: 0.8 }}
>
  <h2>Explore the Possibilities of Hub4Food<sup>®</sup></h2>
  <ul className="info-list">
    <li>Connect with stakeholders to solve agri-food challenges.</li>
    <li>Access cutting-edge technologies across Europe.</li>
    <li>Drive global growth through sustainable solutions.</li>
  </ul>
</motion.section>


        {/* SECÇÃO: Let's Talk?*/}
        <motion.section
          className="info"
          id="lets-talk"
          style={{ marginTop: '100px', width: '100%' }}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <Grid container spacing={8} alignItems="center" justifyContent="center">
            <Grid item xs={12} md={5}>
              <motion.div
                initial={{ opacity: 0, x: -40 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8 }}
                style={{
                  display: 'flex',
                  justifyContent: { xs: 'center', md: 'flex-end' },
                  alignItems: 'center'
                }}
              >
                <Box
                  sx={{
                    borderRadius: '30px',
                    overflow: 'hidden',
                    boxShadow: '0 8px 24px rgba(10, 10, 10, 0.15)',
                    height: { xs: '250px', md: '280px' },
                    width: { xs: '100%', md: '450px' },
                    maxWidth: '100%'
                  }}
                >
                  <img 
                    src="/home-page-ideas.jpg" 
                    alt="Hub4Food Ideas" 
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      display: 'block'
                    }}
                  />
                </Box>
              </motion.div>
            </Grid>

            <Grid item xs={12} md={7}>
              <motion.div
                initial={{ opacity: 0, x: 40 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.2 }}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: { xs: 'center', md: 'flex-start' },
                  height: '100%',
                  paddingLeft: { xs: '0px', md: '40px' }, 
                  textAlign: { xs: 'center', md: 'left' }
                }}
              >
                <Typography 
                  variant="h2" 
                  component="h2"
                  sx={{ 
                    fontWeight: 'bold',
                    mb: 3,
                    fontSize: { xs: '2.2rem', md: '2.8rem' },
                    color: '#333',
                    lineHeight: 1.2,
                    width: '100%'
                  }}
                >
                  Let's talk?
                </Typography>
                
                <Typography 
                  variant="h6" 
                  component="p"
                  sx={{ 
                    mb: 4,
                    lineHeight: 1.6,
                    fontSize: { xs: '1.5rem', md: '1.6rem' },
                    color: '#666',
                    fontWeight: '600',
                    width: '100%'
                  }}
                >
                  +20 ideas submitted · +10 partnerships created · 4 countries connected
                </Typography>
              </motion.div>
            </Grid>
          </Grid>
        </motion.section>
      </Container>
      
      <Box>
        <Footer />
      </Box>
    </Box>
  );
}